import { render, staticRenderFns } from "./Buddies_Rating.vue?vue&type=template&id=d990c77e&scoped=true"
import script from "./Buddies_Rating.vue?vue&type=script&lang=js"
export * from "./Buddies_Rating.vue?vue&type=script&lang=js"
import style0 from "./Buddies_Rating.vue?vue&type=style&index=0&id=d990c77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d990c77e",
  null
  
)

export default component.exports